import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation
} from '@angular/core';
import { CertificateComponent } from '../../sprinklers/certificate-sprinklers/certificate.component';

@Component({
  selector: 'authority-labs-certificate-fire-taps',
  templateUrl: './certificate-fire-taps.component.html',
  styleUrls: ['./certificate-fire-taps.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CertificateFireTapsComponent extends CertificateComponent {}
